import { clsx } from 'clsx'

export const storyAccessorGetBorderRadius = (
  rounded?: number | string,
): string => {
  return clsx(
    rounded === 'none' && 'rounded-none',
    rounded === 'small' && 'rounded-s',
    rounded === 'medium' && 'rounded-m',
    rounded === 'large' && 'rounded-l',
    rounded === 'full' && 'rounded-full',
  )
}
